import {
  ADD_JOB,
} from '../constants/actionTypes';

const initialState = {
  lastJobAdded: null,
};

const addJob = (state = initialState, action) => {
  switch (action.type) {
    case ADD_JOB:
      return {...state, lastJobAdded: action.payload};
    default:
      return state;
  }
}

export default addJob;



// WEBPACK FOOTER //
// ./src/reducers/reducer-addJob.js